import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
    const { status } = useAuth();
    const location = useLocation();

    if (status === "loading") {
        return (
            <div
                data-testid="auth-loading"
                className="min-h-screen flex items-center justify-center"
            >
                <div className="font-serif italic text-ink/60 text-xl animate-fade-in">
                    Une minute, on tisse l&apos;histoire…
                </div>
            </div>
        );
    }
    if (status !== "authed") {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }
    return children;
};

export default ProtectedRoute;
